import * as React from "react";
import { twMerge } from 'tailwind-merge';
type TableProps = React.ComponentProps<"table"> & { height?: string };



function Table({ className, height, ...props }: TableProps) {
  return (
    <div
      data-slot="table-container"
      className={twMerge("relative md:min-h-[60vh] md:max-h-[60vh] w-full overflow-x-auto bg-white rounded-lg shadow-lg ", height)}
    >
      <table
        data-slot="table"
        className={twMerge("w-full caption-bottom text-sm", className)}
        {...props}
      />
    </div>
  );
}

function TableHeader({ className, ...props }: React.ComponentProps<"thead">) {
  return (
    <thead
      data-slot="table-header"
      className={twMerge("[&_tr]:border-b bg-primary text-white text-[16px]", className)}
      {...props}
    />
  );
}

function TableBody({ className, ...props }: React.ComponentProps<"tbody">) {
  return (
    <tbody
      data-slot="table-body"
      className={twMerge("[&_tr:last-child]:border-0", className)}
      {...props}
    />
  );
}

function TableFooter({ className, ...props }: React.ComponentProps<"tfoot">) {
  return (
    <tfoot
      data-slot="table-footer"
      className={twMerge(
        "bg-muted/50 border-t font-medium [&>tr]:last:border-b-0",
        className
      )}
      {...props}
    />
  );
}

function TableRow({ className, ...props }: React.ComponentProps<"tr">) {
  return (
    <tr
      data-slot="table-row"
      className={twMerge(
        "min-h-14 data-[state=selected]:bg-muted border-b transition-colors", // ✅ min-h instead of h
        "[tbody>&]:hover:bg-muted/50",
        "last:border-b last:border-b-gray-200",
        className
      )}
      {...props}
    />
  );
}
function TableHead({ className, ...props }: React.ComponentProps<"th">) {
  return (
    <th
      data-slot="table-head"
      className={twMerge(
        "text-primary-foreground h-14 px-2 text-left align-middle font-medium whitespace-nowrap [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        className
      )}
      {...props}
    />
  );
}

function TableCell({ className, ...props }: React.ComponentProps<"td">) {
  return (
    <td
      data-slot="table-cell"
      className={twMerge(
        "p-2 align-middle max-w-[400px] break-words whitespace-normal [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]",
        className
      )}
      {...props}
    />
  );
}

function TableCaption({
  className,
  ...props
}: React.ComponentProps<"caption">) {
  return (
    <caption
      data-slot="table-caption"
      className={twMerge("text-muted-foreground mt-4 text-sm", className)}
      {...props}
    />
  );
}

export {
  Table,
  TableHeader,
  TableBody,
  TableFooter,
  TableHead,
  TableRow,
  TableCell,
  TableCaption,
};
